import { object, string} from 'yup';


const specialCharPattern = /[!@#$%^&*(),.?":{}|<>_\-+=~`\\[\]/]/g;
const numberPattern = /\d/;
const capitalLetterPattern = /[A-Z]/;
const lowerLetterPattern = /[a-z]/;


export const loginSchema = object({
    email: string().email().required(),
    password: string().required()
});

export const forgetPasswordSchema = object({
    email: string().email().required()
});
export const setPasswordSchema = object({
    password: string().required()
        .matches(specialCharPattern, "specialCharPattern")
        .matches(numberPattern, "numberPattern")
        .matches(capitalLetterPattern, "capitalLetterPattern")
        .matches(lowerLetterPattern, "lowerLetterPattern")
        .max(20, "length")
        .min(8, "length")
});